import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import '../styles/PlanDetail.css';
import Loader from '../components/Loader';

const PlanDetail = ({ user }) => {
  const { planKey } = useParams();
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const docRef = doc(db, "users", "plans");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const plansData = docSnap.data();
          const selectedPlan = plansData[planKey];
          setPlan(selectedPlan);
        }
      } catch (err) {
        console.error("Error fetching plan:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPlan();
  }, [planKey]);

  const handleInvest = () => {
    navigate(user ? '/fxt/trade' : '/login');
  };

  if (loading) {
    return <Loader />;
  }

  if (!plan) {
    return (
      <div className="plan-detail-error">
        <h2>Plan not found</h2>
        <button onClick={() => navigate('/investments')}>Back to Investments</button>
      </div>
    );
  }

  return (
    <div className="plan-detail-page">
      <div className="plan-detail-container">
        <button className="back-btn" onClick={() => navigate('/investments')}>
          ← Back
        </button>

        <div className="plan-detail-card">
          <div className="plan-detail-header">
            <span className="plan-detail-badge">Investment Plan</span>
            <h1 className="plan-detail-name">{plan.name}</h1>
            <span className="plan-detail-price">{plan.price}</span>
          </div>

          <div className="plan-detail-stats">
            <div className="detail-stat">
              <span className="detail-label">Duration</span>
              <span className="detail-value">{plan.durationDisplay}</span>
            </div>
            <div className="detail-stat">
              <span className="detail-label">Profit</span>
              <span className="detail-value highlight">+{plan.profit}%</span>
            </div>
            <div className="detail-stat">
              <span className="detail-label">TPS</span>
              <span className="detail-value">{plan.maxTps}</span>
            </div>
          </div>

          <div className="plan-detail-info">
            <div className="info-row">
              <span className="info-label">Amount</span>
              <span className="info-value">${plan.amount}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Chains</span>
              <span className="info-value">{plan.chains}</span>
            </div>
            <div className="info-row">
              <span className="info-label">Efficiency</span>
              <span className="info-value">{plan.efficiency}</span>
            </div>
          </div>

          {plan.hardware && (
            <div className="description-section">
              <h3>Description</h3>
              <p>{plan.hardware}</p>
            </div>
          )}

          {plan.specs && (
            <div className="plan-detail-specs">
              <h3>Features</h3>
              <ul>
                {(() => {
                  let specsArr = [];
                  if (Array.isArray(plan.specs)) {
                    specsArr = plan.specs;
                  } else if (plan.specs && typeof plan.specs === 'object') {
                    specsArr = Object.values(plan.specs).filter(v => typeof v === 'string');
                  }
                  return specsArr.map((spec, idx) => <li key={idx}>{spec}</li>);
                })()}
              </ul>
            </div>
          )}

          <span className="invest-btn" onClick={handleInvest}>
            {user ? 'Start Investing' : 'Login to Invest'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PlanDetail;